import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons';

const AccessPendingPage: React.FC = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const spanish = i18n.language.toLowerCase().startsWith('es');
  const supportEmail = (import.meta as any).env?.VITE_SUPPORT_EMAIL || 'contacto@taratic.com';

  return (
    <div className="min-h-screen bg-[#0f0f13] text-white flex items-center justify-center px-4">
      <div className="w-full max-w-lg rounded-3xl border border-white/10 bg-white/5 p-8 text-center shadow-2xl backdrop-blur-xl">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-amber-500/15 text-amber-300">
          <FontAwesomeIcon icon={faLock} className="text-2xl" />
        </div>
        <h1 className="text-3xl font-black">
          {spanish ? 'Acceso pendiente' : 'Access pending'}
        </h1>
        <p className="mt-4 text-white/70 leading-7">
          {spanish
            ? 'Tu correo no está autorizado actualmente para usar Taratic. Hemos avisado a nuestro equipo de soporte, que podrá contactarte en esa dirección.'
            : 'Your email is not currently authorized to use Taratic. We’ve notified our support team, who may contact you at that email address.'}
        </p>
        <a className="mt-5 inline-flex items-center gap-2 text-indigo-300 hover:text-indigo-200" href={`mailto:${supportEmail}`}>
          <FontAwesomeIcon icon={faEnvelope} /> {supportEmail}
        </a>
        <button onClick={() => navigate('/login')} className="mt-8 w-full btn-taratic btn-ghost-dark rounded-xl px-5 py-3 font-bold">
          {spanish ? 'Volver al inicio de sesión' : 'Return to login'}
        </button>
      </div>
    </div>
  );
};

export default AccessPendingPage;
